import React from "react"

import { NewsPanel, SpNewsPanel } from "components/organisms/panel/newsList"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { checkIsSp } from "utils/util"

export const NewsTemplate = () => {
  const isPhone = checkIsSp()

  return (
    <MainContainer className="news">
      <div>{!isPhone ? <NewsPanel isNewsTab={true} /> : <SpNewsPanel />}</div>
    </MainContainer>
  )
}
